<template>
  <div class="partner-root">
    <Form @submit="onSubmit">
      <Field
        v-model="username"
        name="name"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <Field
        v-model="phoneNUmber"
        name="mobile"
        label="联系方式"
        type="tel"
        placeholder="请输入联系方式"
        :rules="[{ required: true, message: '请填写联系方式' }]"
      />
      <Field
        v-model="live"
        name="address"
        label="长期居住地"
        placeholder="请输入居住地"
        :rules="[{ required: true, message: '请填写居住地' }]"
      />
      <Field
        v-model="office"
        name="professional"
        label="现就职"
        placeholder="请输入现就职"
        :rules="[{ required: true, message: '请填写现就职' }]"
      />
      <Field
        v-model="message"
        name="reason"
        rows="2"
        autosize
        label="申请理由"
        type="textarea"
        maxlength="50"
        placeholder="请输入申请理由或资源"
        show-word-limit
      />
      <div style="margin: 16px;">
        <Button round block type="info" native-type="submit">
          提交
        </Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { api,http } from 'utils/'
export default {
  data() {
    return{
      username:"",
      phoneNUmber:"",
      live:"",
      office:"",
      message:""
    }
  },
  created() {
    document.title = '城市合伙人'
  },
  methods:{
    async postHandle(data) {
      const res = await http({
        url:api.partnerApi,
        method:'POST',
        data:{
          ...data
        }
      })
      if(res) {
        this.$router.push('/success')
      }
      console.log(res)
    },
    onSubmit(values) {
      this.postHandle(values)
      console.log('submit', values);
    }
  }
}
</script>

<style lang="less">
.partner-root{
  .van-cell__title {
    text-align: left;
  }
}
</style>